(function (w) {
	'use strict';

	SearchContext.prototype = Object.create((((mx || {}).shell || {}).SearchContext || {}).prototype || {});

	function SearchContext(options) {
		mx.shell.SearchContext.call(this, options);
		Object.defineProperty(this, 'datasource', {
			writable: true,
			value: options.dataQuery || '',
		});
		Object.defineProperty(this, 'widgetId', {
			writable: true,
			value: options.widgetId || '',
		});
		Object.defineProperty(this, 'userEntityName', {
			writable: true,
			value: options.userEntityName || 'SPSUserClassBase',
		});
		Object.defineProperty(this, 'statusEntityName', {
			writable: true,
			value: options.statusEntityName || 'SPSCommonPickupObjectStatus',
		});
		Object.defineProperty(this, 'statusEntityStateGroup', {
			writable: true,
			value: options.statusEntityStateGroup || 7,
		});
		Object.defineProperty(this, 'selected', {
			writable: true,
			value: options.selected || false,
		});
		Object.defineProperty(this, 'navigationItem', {
			writable: true,
			value: options.navigationItem,
		});
	}

	w.mx = w.mx || {};
	w.mx.SolutionBuilderAgent = w.mx.SolutionBuilderAgent || {};
	w.mx.SolutionBuilderAgent.SearchContext = SearchContext;
})(window);
